<template lang="pug">
  v-dialog(v-model="showModal" width="500" persistent)
    v-card.primary--text
      v-card-title(v-if="title") {{ title }}

      v-card-text.primary--text.mt-5
        p.text-pre-wrap(v-if="!hideMessage") {{ text }}
        v-checkbox.mt-0.confirm-checkbox(
          v-if="showCheckbox"
          v-model="isConfirmed"
          :label="checkboxLabel"
          hide-details
        )

      v-card-actions.pa-5
        v-btn.btn-no-shadow(color="secondary" large :disabled="!isConfirmed" @click="onOk")
          span.primary--text Ja

        v-spacer

        v-btn(color="secondary" large outlined @click="onCancel")
          span.primary--text Nein

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class NConfirmDialog extends Vue {
  showModal = false
  showCheckbox = false
  title = ''
  text = ''
  hideMessage = false
  checkboxLabel = ''
  handleOk = null
  handleCancel = null
  isConfirmed = true

  onOk () {
    if (this.handleOk && typeof this.handleOk === 'function') {
      this.handleOk()
    }
  }

  show (options = {}) {
    this.title = options.title || 'Achtung'
    this.text = options.text || ''
    this.handleOk = options.handleOk || (() => {})
    this.handleCancel = options.handleCancel || (() => {})
    this.showModal = true
    this.showCheckbox = options.showCheckbox || false
    this.checkboxLabel = options.checkboxLabel || ''
    this.hideMessage = options.hideMessage || false

    if (this.showCheckbox) {
      this.isConfirmed = false
    }
  }

  onCancel () {
    this.close()
    if (this.handleCancel && typeof this.handleCancel === 'function') {
      this.handleCancel()
    }
  }

  close () {
    this.showModal = false
  }
}
</script>
